import React from 'react';
import {css} from "emotion";
import Layout from '../layout';
import history from '../../utils/history';
import IconEasySurvey from '../common/material-easy-ui/icon/IconEasySurvey';
import IconEasyNews from '../common/material-easy-ui/icon/IconEasyNews';
import IconEasyProfile from '../common/material-easy-ui/icon/IconEasyProfile';

const HomePage = (props) =>{

  const goToListForm = () =>{
    history.push({pathname:'/liste-formulaire'})
  }

  const goToListDeclaration = ()=>{
    history.push({pathname:'/vos-déclarations'})
  }

  const goToProfile = () =>{
    history.push({pathname:'/profil'})
  }

  return(
    <Layout location={props.location}>
    <div className={css`max-width:678px;margin:0 auto`}>
      <div
       onClick={goToListForm}
       className={css`&:hover{
        -moz-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
        -webkit-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
        -o-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
        box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);};
        cursor:pointer;
        background-color:white;height:100px;margin-top:20px;display:flex;align-items:center;box-sizing:border-box;padding-left:20px;padding-right:20px`}>
        <div className={css`background-color:#0084C6;height:50px;width:50px;display:flex;align-items:center;justify-content:center;border-radius:10px`}>
        <IconEasySurvey color={'white'} size={40}/>
        </div>
        <div className={css`flex:1;margin-left:30px;font-weight:600;color:#0084C6`}>
          <div>LES FORMULAIRES</div>
          <div className={css`font-size:13px;margin-top:10px;color:#3f4d6e`}>Accéder aux formulaires du Parc national des Calanques</div>
        </div>
      </div>

      <div
      onClick={goToListDeclaration}
      className={css`
        &:hover{
          -moz-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
          -webkit-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
          -o-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
          box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);};
          cursor:pointer;
        background-color:white;height:100px;margin-top:20px;display:flex;align-items:center;box-sizing:border-box;padding-left:20px;padding-right:20px`}>
        <div className={css`background-color:#0084C6;height:50px;width:50px;display:flex;align-items:center;justify-content:center;border-radius:10px`}>
        <IconEasyNews color={'white'} size={40}/>
        </div>
        <div className={css`flex:1;margin-left:30px;font-weight:600;color:#0084C6`}>
          <div>VOS DÉCLARATIONS</div>
          <div className={css`font-size:13px;margin-top:10px;color:#3f4d6e`}>Visualisez l'ensemble de toutes vos déclarations</div>
          </div>
      </div>

      <div
       onClick={goToProfile}
       className={css`
        &:hover{
          -moz-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
          -webkit-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
          -o-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
          box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);};
          cursor:pointer;
        background-color:white;height:100px;margin-top:20px;display:flex;align-items:center;box-sizing:border-box;padding-left:20px;padding-right:20px`}>
        <div className={css`background-color:#0084C6;height:50px;width:50px;display:flex;align-items:center;justify-content:center;border-radius:10px`}>
        <IconEasyProfile color={'white'} size={40}/>
        </div>
        <div className={css`flex:1;margin-left:30px;font-weight:600;color:#0084C6`}>
          <div>VOTRE PROFIL</div>
          <div className={css`font-size:13px;margin-top:10px;color:#3f4d6e`}>Prévisualiser et modifier votre profil</div>
          </div>
      </div>

      </div>
    </Layout>
  )
}

export default HomePage;
